import { ENTER } from '@angular/cdk/keycodes';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { WoundService } from 'src/app/services/wound.service';
import { PatientRoundingSheetService } from '../../patient-rounding-sheets/patient-rounding-sheet.service';


export interface ProcedureType {
  _id?: string,
  title: string,

  createdAt: string|Date,
  updatedAt: string|Date,
}
export interface CPTCode {
    _id? : string,
    description: string,
    code: string,
}
export interface ProcedureDataset {
  _id?: string,
  procedure_type_id: ProcedureType | string,
  
  category: string,
  size: string,
  code_1: CPTCode,
  code_2: CPTCode,
  code_3: CPTCode,
  template: string,
  createdAt: string|Date,
  updatedAt: string|Date,

}


@Component({
  selector: 'app-procedure-datasets',
  templateUrl: './procedure-datasets.component.html',
  styleUrls: ['./procedure-datasets.component.css']
})
export class ProcedureDatasetsComponent implements OnInit {
  @Input() company_id:string;
  separatorKeysCodes: number[] = [ENTER];
 
  procedureTypes: ProcedureType[] = [];
  activeProcedureType:ProcedureType = null;

  procedureDatasets: ProcedureDataset[] = null;

  loaderId = 'app-procedure-datasets';
  loaderId2 = 'app-procedure-types';

  newProcedureTypeInputValue:string = '';
  showNewProcedureTypeInput = false;
  editingProcedureType:ProcedureType= null;

  cptCodeList: any = [];
  tabIndex: number = 0;
  selectedTabIndex: number = 0;
  activatedRouter: string = "Mapping";
  currentUser: any;

  constructor(private _wound: WoundService,
    private toastr: ToastrService,
    private _authService: AuthService,
    private loader: NgxUiLoaderService) {
    this.currentUser = this._authService.currentUser;
  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    await this.initProcedureType();
    this.loader.stopLoader(this.loaderId);
  }
  ngOnDestroy(): void {
    localStorage.removeItem("procedureDatasets");
  }
  async initProcedureType() {
    let {status, data} = await lastValueFrom(this._wound.getProcedureTypes(this.company_id)) as any;
    if (status == 200) {
      this.procedureTypes = data.array as ProcedureType[];
    }
  }



  async initProcedureDatasets() {
    let {status, data} = await lastValueFrom(this._wound.getProcedureDatasets(this.activeProcedureType._id)) as any;
    if (status == 200) {
      this.procedureDatasets = data.array as ProcedureDataset[];
      localStorage.setItem("procedureDatasets",JSON.stringify(this.procedureDatasets));
      // this.selectedICDCode = this.icdCodeList.find(icdcode => icdcode.code == this.woundEtiologyGroupDetails.icd_id.code);
      // 

    }
  }



  isEditingProcedureType(procedureType, i) {
    return this.editingProcedureType === procedureType;
  }

  async addNewProcedureType(value, i?) {
    const infoToast = this.toastr.info('Adding Procedure Type', 'Please wait', { disableTimeOut: true });
    let {status, data} = await lastValueFrom(this._wound.addProcedureType(this.company_id, value)) as any;
    if (status == 200) {
      this.procedureTypes.push(data as ProcedureType);
      this.newProcedureTypeInputValue = '';
      this.showNewProcedureTypeInput = false;
      this.toastr.clear(infoToast.toastId);
      this.toastr.success("Added Successfully", "Success");
    }else{
      this.toastr.clear(infoToast.toastId);
    }
  }
  editProcedureType(procedureType, i) {
    console.log(procedureType);
    this.editingProcedureType = procedureType;
    this.newProcedureTypeInputValue = '';    
  }


  handleAddNewProcedureType() {
    this.showNewProcedureTypeInput = true;
  }
  handleEditProcedureTypeInputValueChange($event, i) {
    // is enter key pressed
    console.log({
      '$event.keyCode': $event.keyCode,
      $event,
      i
    });
    if ($event.keyCode === ENTER) {
      this.addNewProcedureType($event.target.value, i);
      this.editingProcedureType = null;
    }
  }

  updateProcedureType(value, i) {
    console.log({value, i})
    this.procedureTypes[i].title = value;
    this.editingProcedureType = null;
  }

  async deleteProcedureType(procedureType, i) {

    const infoToast = this.toastr.info('Deleting Procedure Type', 'Please wait', { disableTimeOut: true });
    const {status, data} = await lastValueFrom(this._wound.updateProcedureType(procedureType._id, undefined, true)) as any;
    if(status == 200) {
      if(this.activeProcedureType?._id == procedureType._id) {
        this.activeProcedureType = null;
      }
      this.toastr.clear(infoToast.toastId);
      this.toastr.success("Deleted Successfully", "Success");
      this.procedureTypes.splice(i, 1);
    }
  }

  // editWoundEtiologyGroupDetails(woundEtiologyGroupDetails, i) {
  //   console.log(woundEtiologyGroupDetails);
  //   this.editingWoundEtiologyGroupDetails = woundEtiologyGroupDetails;
  //   this.newInputValue = woundEtiologyGroupDetails.title;
  // }

  async handleProcedureTypeClick(procedureType, i) {
    this.loader.startLoader(this.loaderId2);
    this.activeProcedureType = procedureType;
    await this.initProcedureDatasets();
    this.selectedTabIndex = 0;
    this.tabIndex = 0;
    this.activatedRouter = 'Mapping';
    this.loader.stopLoader(this.loaderId2);
  } 

  addRelation(icdcode){
    console.log(icdcode)
  }
  onTabClick(event:any){
    if (event?.index == 0) {
      this.tabIndex = 0;
      this.activatedRouter = 'Mapping';
      this.selectedTabIndex = 0;
    }
    else if(event?.index == 1){
      this.tabIndex = 1;
      this.activatedRouter = 'Category Templates';
      this.selectedTabIndex = 1;
    }
  }
}
